import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';

function DashboardCard ({ heading, icon, description, path })  {

  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(path);
  };

  return (
    <div 
      onClick={handleCardClick}
      className="w-full max-w-sm rounded-lg overflow-hidden shadow-md bg-white px-2 sm:px-4 mx-auto group hover:shadow-lg cursor-pointer">
      <div className="flex justify-center">
        <FontAwesomeIcon 
          className="w-10 h-10 sm:w-12 sm:h-12 md:w-16 md:h-16 my-4 transition-transform duration-300 transform group-hover:scale-105 text-[#BE1F18]"
          icon={icon} 
        />
      </div>
      <div className="px-4 py-2 sm:px-6 sm:py-3 md:px-8 md:py-4 text-center">
        <div className="font-semibold text-sm sm:text-lg mb-4 group-hover:text-red-600 cursor-pointer whitespace-nowrap">
          {heading}
        </div>
        <p className="text-gray-500 text-xs sm:text-sm text-center mb-4">
          {description}
        </p>
      </div>
    </div>
  );
};

DashboardCard.propTypes = {
  heading: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  description: PropTypes.string.isRequired,
};

export default DashboardCard;
